"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

/** Base label styles. Disables interaction when the associated peer element is disabled. */
const labelVariants = cva(
	"text-base font-medium leading-normal text-field-label peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

/**
 * Accessible label wrapping `@radix-ui/react-label`.
 *
 * @param props.className - Merged with {@link labelVariants} styles.
 * @param ref - Forwarded to `LabelPrimitive.Root`.
 */
const Label = React.forwardRef<
	React.ElementRef<typeof LabelPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
		VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(labelVariants(), className)}
		{...props}
	/>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
